import { createSlice } from '@reduxjs/toolkit';
import {
  getListingsReducers,
  getListingReducers,
  deleteListingReducers,
  updateListingReducers,
  deleteListingsByFilterReducers,
} from './listings.reducers';

const initialState = {
  listings: [],
  totalListings: 0,
  totalPages: 0,
  currentPage: 1,
  currentListing: null,

  getListingsStatus: 'idle',
  getListingByIdStatus: 'idle',
  deleteListingStatus: 'idle',
  updateListingStatus: 'idle',
  deleteListingsByFilterStatus: 'idle',

  error: null,
};

const listingsSlice = createSlice({
  name: 'listings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getListingsReducers(builder);
    getListingReducers(builder);
    deleteListingReducers(builder);
    updateListingReducers(builder);
    deleteListingsByFilterReducers(builder);
  },
});

export default listingsSlice.reducer;
